import { render, staticRenderFns } from "./PopupNewPageForm.vue?vue&type=template&id=227ed3f6"
import script from "./PopupNewPageForm.vue?vue&type=script&lang=js"
export * from "./PopupNewPageForm.vue?vue&type=script&lang=js"
import style0 from "./PopupNewPageForm.vue?vue&type=style&index=0&id=227ed3f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports